import { render, staticRenderFns } from "./ViewSingleAssistance.vue?vue&type=template&id=5c06f4df&"
import script from "./ViewSingleAssistance.vue?vue&type=script&lang=js&"
export * from "./ViewSingleAssistance.vue?vue&type=script&lang=js&"
import style0 from "./ViewSingleAssistance.vue?vue&type=style&index=0&id=5c06f4df&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports